import { useFilePreview } from "@jugl-web/domain-resources/files/providers/FilePreviewProvider";
import mime from "mime";
import { useCallback } from "react";

export type UseCommentAttachmentPreviewOptions = {
  onDownload?: (url: string, name: string) => void;
};

export const useCommentAttachmentPreview = (
  options?: UseCommentAttachmentPreviewOptions
) => {
  const { previewFile, previewFiles } = useFilePreview();
  const { onDownload } = options ?? {};

  const handleAttachmentClick = useCallback(
    (url: string, allUrls: string[]) => {
      const configs = allUrls.map((attachmentUrl) => {
        const name = decodeURIComponent(
          attachmentUrl.split("/").pop()?.split("?")[0] || "file"
        );

        return {
          url: attachmentUrl,
          name,
          mimeType: mime.getType(attachmentUrl) || "application/octet-stream",
          onDownload: () =>
            onDownload
              ? onDownload(attachmentUrl, name)
              : window.open(attachmentUrl, "_blank"),
        };
      });

      if (configs.length === 1) {
        previewFile(configs[0]);
        return;
      }

      previewFiles(configs, url);
    },
    [onDownload, previewFile, previewFiles]
  );

  return { handleAttachmentClick };
};
